/**
 * TanStack Query hooks for `linear-attribution`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	linearAttributionQueryKeys,
	type CreateLinearAttributionBody,
	type ListLinearAttributionResponse,
	type LinearAttributionRow,
} from "./api";

export function useLinearAttributionList(): UseQueryResult<ListLinearAttributionResponse, Error> {
	return useQuery({
		queryKey: linearAttributionQueryKeys.list(),
		queryFn: list,
	});
}

export function useLinearAttributionCreate(): UseMutationResult<LinearAttributionRow, Error, CreateLinearAttributionBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: linearAttributionQueryKeys.all });
		},
	});
}

export function useLinearAttributionDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: linearAttributionQueryKeys.all });
		},
	});
}
